import { Stack, Typography } from "@mui/material";
import { useGetSavedSearchQuery, useGetSuggestedSearchQuery } from "api";
import SavedSearchCard from "components/SavedSearchCard";
import { SugestedSearchCard } from "components/SavedSearchCard/SugestedSearchCard";
import TrendingList from "components/TrendingList";

const SavedSearches = () => {
  const { data, loading } = useGetSavedSearchQuery({
    variables: {
      offset: 0,
      limit: 10,
    },
  });
  const { data: SuggestedSearch } = useGetSuggestedSearchQuery({
    variables: {
      offset: 0,
      limit: 10,
    },
  });
  if (
    !loading &&
    !data?.getSavedSearch?.length &&
    !SuggestedSearch?.getSuggestedSearch?.length
  )
    return null;
  return (
    <TrendingList title="Saved Search" seeAllLink="/saved-searches">
      <>
        {data?.getSavedSearch?.slice(0, 10)?.map((searchItem) => (
          <SavedSearchCard
            key={searchItem?.searchId}
            searchItem={searchItem}
            hideRemoveButton
          />
        ))}
        {Number(data?.getSavedSearch?.slice(0, 10)?.length) <= 0 && (
          <Typography
            variant="caption"
            sx={{
              fontSize: "12px",
              paddingLeft: "16px",
              paddingBottom: "12px",
              paddingTop: "4px",
              display: "block",
            }}
          >
            You have no saved searches yet.
          </Typography>
        )}
        {Number(SuggestedSearch?.getSuggestedSearch?.slice(0, 10)?.length) >
          0 && (
          <Stack>
            <Typography variant="caption" style={{ paddingLeft: "15px" }}>
              Suggested
            </Typography>
          </Stack>
        )}
        {SuggestedSearch?.getSuggestedSearch
          ?.slice(0, 10)
          ?.map((searchItem) => (
            <SugestedSearchCard
              key={searchItem?.searchId}
              searchItem={searchItem}
            />
          ))}
      </>
    </TrendingList>
  );
};

export default SavedSearches;
